import React, { useState } from 'react';
import { AppBar, Toolbar, Box, Button, IconButton, Drawer, List, ListItem, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const navItems = [
    { label: 'Home', route: '/' },
    { label: 'About', route: '/about' },
    { label: 'Vision', route: '/vision' },
    { label: 'Products', route: '/products' },
    { label: 'Contact', route: '/contact' },
  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navigateToPage = (route) => {
    navigate(route);
    setMobileOpen(false);
  };

  const drawer = (
    <Box sx={{ width: 250, backgroundColor: '#1A1A1A', height: '100%', pt: 4 }}>
      <List>
        {navItems.map((item) => (
          <ListItem 
            button 
            key={item.label} 
            onClick={() => navigateToPage(item.route)}
            sx={{ 
              color: '#FFFFFF',
              '&:hover': { backgroundColor: '#2B5A9E' }
            }}
          >
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar
        position="fixed"
        component={motion.div}
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5 }}
        sx={{
          backgroundColor: 'transparent',
          boxShadow: 'none',
        }}
      >
        <Toolbar sx={{ justifyContent: 'flex-end', py: { xs: 1, md: 2 }, px: { xs: 1, md: 2 } }}>
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
            {navItems.map((item) => (
              <Button
                key={item.label}
                onClick={() => navigateToPage(item.route)}
                sx={{
                  color: '#FFFFFF',
                  fontFamily: 'Roboto',
                  fontSize: '14px',
                  fontWeight: 500,
                  letterSpacing: '0.05em',
                  backgroundColor: 'rgba(0, 0, 0, 0.3)',
                  backdropFilter: 'blur(10px)',
                  px: 3,
                  py: 1,
                  borderRadius: '8px',
                  '&:hover': {
                    backgroundColor: 'rgba(40, 88, 168, 0.8)',
                  },
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>

          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ 
              display: { md: 'none' },
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              p: 1,
              '&:hover': {
                backgroundColor: 'rgba(40, 88, 168, 0.8)',
              },
            }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{ display: { xs: 'block', md: 'none' } }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default Navbar;
